import { HistoricoCupom } from '../../../../interfaces/historico-paciente';

/** Mesmas regras de tipo, valor e validade da aba Cupons do Histórico do Paciente. */
export interface CupomExibido {
  codigo: string;
  descricao: string | null;
  tipo: string;
  rotuloTipo: string;
  desconto: string;
  rotuloDesconto: string;
  quantidade: number;
  validade: string;
  vencendo: boolean;
}

const BRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
const brl = (v: number | null | undefined) => BRL.format(v ?? 0);

export function rotuloTipoCupom(tipo: string | null | undefined): string {
  switch (tipo) {
    case 'V': return 'Grátis';
    case 'P': return 'Percentual';
    case 'F': return 'Valor fixo';
    case 'R': return 'Desconto em R$';
    default: return 'Sem tipo';
  }
}

export function descontoCupom(c: HistoricoCupom): { rotulo: string; valor: string } {
  switch (c.tipo) {
    case 'V': return { rotulo: 'zerado', valor: 'Grátis' };
    case 'P': return { rotulo: 'de desconto', valor: `${c.prDesconto ?? 0}%` };
    case 'F': return { rotulo: 'sai por', valor: brl(c.vlDesconto) };
    case 'R': return { rotulo: 'de desconto', valor: `- ${brl(c.vlDesconto)}` };
    default: return { rotulo: 'valor', valor: brl(c.valorCupom) };
  }
}

/** O back manda dd/MM/yyyy; ISO também é aceito. */
function dataCupom(s: string | null | undefined): Date | null {
  if (!s) return null;
  const br = /^(\d{2})\/(\d{2})\/(\d{4})/.exec(s);
  if (br) return new Date(+br[3], +br[2] - 1, +br[1]);
  const d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
}

export function diasParaVencer(c: HistoricoCupom, hoje: Date): number | null {
  const d = dataCupom(c.dtExpiracao);
  if (!d) return null;
  const h = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
  return Math.round((d.getTime() - h.getTime()) / 86_400_000);
}

export function textoValidade(dias: number | null, dtExpiracao: string | null | undefined): string {
  if (dias === null) return 'Sem data de validade';
  const quando = dias === 0 ? 'Vence hoje' : dias === 1 ? 'Vence amanhã' : `Vence em ${dias} dias`;
  return dtExpiracao ? `${quando} · ${dtExpiracao.slice(0, 10)}` : quando;
}

/** Quem vence primeiro vem primeiro; sem validade vai para o fim. */
export function cuponsExibidos(lista: HistoricoCupom[], hoje: Date): CupomExibido[] {
  const chave = (c: HistoricoCupom) => diasParaVencer(c, hoje) ?? Number.MAX_SAFE_INTEGER;
  return [...lista].sort((a, b) => chave(a) - chave(b)).map(c => {
    const dias = diasParaVencer(c, hoje);
    const d = descontoCupom(c);
    return {
      codigo: c.codigo || 'Cupom sem código',
      descricao: c.descricao,
      tipo: c.tipo || 'x',
      rotuloTipo: rotuloTipoCupom(c.tipo),
      desconto: d.valor,
      rotuloDesconto: d.rotulo,
      quantidade: c.quantidade || 1,
      validade: textoValidade(dias, c.dtExpiracao),
      vencendo: dias !== null && dias <= 7,
    };
  });
}
